import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import type { CollectionSlug, CollectionUUID } from '@library/menu-service'
import { queueTrackingEvent } from '@library/tracking-integration'

import { actionTypes } from 'actions/actionTypes'
import { clickMerchandisingBanner } from 'actions/trackingKeys'
import { useSelectCollection } from 'hooks/menu-collections'
import type { SelectCollectionEvent } from 'routes/Menu/MenuExperience/types'

const useChangeCollectionById = (collectionId: CollectionUUID) => {
  const selectCollection = useSelectCollection()
  const dispatch = useDispatch()

  return useCallback(() => {
    if (collectionId) {
      selectCollection(collectionId, (oldCollection, newCollection) => {
        if (newCollection && oldCollection?.id !== newCollection?.id) {
          dispatch({
            type: actionTypes.FILTERS_COLLECTION_CHANGE,
            collectionName: newCollection.slug,
            collectionId: newCollection.id,
            trackingData: {
              actionType: actionTypes.RECIPE_COLLECTION_SELECTED,
              collectionId: newCollection.id,
            },
          })

          dispatch({
            type: actionTypes.TRACKING,
            trackingData: {
              actionType: clickMerchandisingBanner,
              collection_id: newCollection.id,
              click_collection_id: oldCollection?.id || null,
            },
          })
        }
      })
    }
  }, [collectionId, dispatch, selectCollection])
}

export const useWaveLinkHeaderClick = (collectionId?: string, collectionSlug?: string) => {
  const typedCollectionId = (collectionId || '') as CollectionUUID
  const typedCollectionSlug = (collectionSlug || '') as CollectionSlug
  const changeCollectionById = useChangeCollectionById(typedCollectionId)

  return useCallback(() => {
    queueTrackingEvent<SelectCollectionEvent>({
      action: 'select_collection',
      properties: {
        collection_id: typedCollectionId,
        collection_slug: typedCollectionSlug,
        navigation_method: 'menu_banner',
      },
    })
    changeCollectionById()
  }, [changeCollectionById, typedCollectionId, typedCollectionSlug])
}
